/**
 * Badge per la gravita' di un rilievo fiscale (verifiche_fiscali.gravita).
 *
 * Solo due valori ammessi dal CHECK di database (migration 0018,
 * ck_verifiche_gravita): 'blocco' e 'attenzione'. Distinto da StatoBadge
 * (quello e' semantica SDI: bozza/consegnata/scartata, un dominio diverso),
 * per non fargli portare un significato che non gli appartiene.
 *
 * Il colore NON e' l'unico portatore del significato (icona diversa per i
 * due valori): un rilievo di gravita' e' spesso l'unica cosa che decide se
 * aprire subito la fattura o rimandare, e non tutti i monitor rendono bene
 * la differenza fra rosso e ambra.
 *
 * Importa esclusivamente da @floraltech/ui (regola 6.8 CLAUDE.md).
 */

import { Badge } from '@floraltech/ui';
import { AlertOctagon, AlertTriangle } from 'lucide-react';
import React from 'react';

interface GravitaBadgeProps {
  /** 'blocco' | 'attenzione' - qualsiasi altro valore e' mostrato cosi' com'e'. */
  gravita: string;
  className?: string;
}

const GravitaBadge: React.FC<GravitaBadgeProps> = ({ gravita, className }) => {
  if (gravita === 'blocco') {
    return (
      <Badge variant="destructive" className={className}>
        <AlertOctagon className="mr-1 h-3 w-3" />
        Blocco
      </Badge>
    );
  }
  if (gravita === 'attenzione') {
    return (
      <Badge variant="warning" className={className}>
        <AlertTriangle className="mr-1 h-3 w-3" />
        Attenzione
      </Badge>
    );
  }
  return (
    <Badge variant="secondary" className={className}>
      {gravita}
    </Badge>
  );
};

export default GravitaBadge;
